import {
  Box,
  Typography,
  Button,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { Link as RouterLink } from 'react-router-dom';
import PageSeo, {
  absoluteUrl,
  breadcrumbJsonLd,
  keywordSets,
} from './PageSeo';
import bydsealion7 from './images/byd-sealion-7.jpg';
import bydsealionHarga from './images/byd-sealion-7-connectivity-23.jpg';
import bydsealionSpek from './images/byd-sealion-7-connectivity-24.jpg';
import bydsealionTempat from './images/byd-sealion-7-exterior-03.jpg';
import bydsealionKeunggulan from './images/byd-sealion-7-exterior-04.jpg';
import bydsealionRamah from './images/byd-sealion-7-interior-06.jpg';
import bydsealionKeluarga from './images/byd-sealion-7-interior-07.jpg';
import bydsealionPesan from './images/byd-sealion-7-interior-13.jpg';
import bydsealionSerpong from './images/byd-sealion-7-interior-14.jpg';
import seagullpeluncuran from './images/BYD-SEAGULL-Launch-Indonesia.jpg';
import warnaseagull from './images/2023-04-28-104821-1024x768.jpg';
import interiorseagull from './images/interior-seagull-8.jpg';
import exteriorseagull from './images/seagull-sg-5.png';
import seagullfitur from './images/seagull-fitur.jpg';
import denzad9spect from './images/byd-denza-d9-side.jpeg';
import denzad9 from './images/denza-d9.webp';
import m6HeroV2L from './images/vtol-pc.webp';
import bydatto3 from './images/image_0.jpeg';
import sealionhero from './images/sealion-7.jpg';
import m6dmBlog from './images/bydm6dm/blog-1.jpeg';
import m6dmHarga from './images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.24 AM.jpeg';
import atto1Perubahan from './images/atto-1-perubahan/WhatsApp Image 2026-05-15 at 9.13.17 AM.jpeg';

const blogs = [
  {
    id: 1,
    title: 'Kenapa Memilih BYD Sealion 7 sebagai Mobil Listrik Anda?',
    description:
      'Cari tahu alasan BYD Sealion 7 menjadi pilihan terbaik untuk mobil listrik modern.',
    image: bydsealion7,
    slug: 'kenapa-memilih-byd-sealion-7',
    contentLength: '450 kata',
  },
  {
    id: 2,
    title: 'Harga BYD Sealion 7: Apa yang Membuatnya Bernilai Tinggi?',
    description:
      'Detail tentang harga dan keunggulan dari mobil listrik BYD Sealion 7.',
    image: bydsealionHarga,
    slug: 'harga-byd-sealion-7',
    contentLength: '500 kata',
  },
  {
    id: 3,
    title: 'Spesifikasi Lengkap BYD Sealion 7',
    description:
      'Jelajahi spesifikasi BYD Sealion 7, SUV listrik inovatif dengan performa tinggi.',
    image: bydsealionSpek,
    slug: 'spesifikasi-lengkap-byd-sealion-7',
    contentLength: '550 kata',
  },
  {
    id: 4,
    title: 'Dealer Resmi BYD Serpong: Tempat Membeli BYD Sealion 7',
    description:
      'Temukan BYD Sealion 7 di Dealer Resmi BYD BSD Serpong dengan penawaran menarik.',
    image: bydsealionTempat,
    slug: 'dealer-resmi-byd-serpong',
    contentLength: '400 kata',
  },
  {
    id: 5,
    title: 'Keunggulan Teknologi di BYD Sealion 7',
    description:
      'Pelajari fitur teknologi canggih yang menjadikan BYD Sealion 7 unggul di kelasnya.',
    image: bydsealionKeunggulan,
    slug: 'keunggulan-teknologi-byd-sealion-7',
    contentLength: '600 kata',
  },
  {
    id: 6,
    title: 'BYD Sealion 7: Mobil Listrik Ramah Lingkungan',
    description:
      'Cari tahu bagaimana BYD Sealion 7 berkontribusi pada lingkungan dengan teknologi hijau.',
    image: bydsealionRamah,
    slug: 'byd-sealion-7-ramah-lingkungan',
    contentLength: '500 kata',
  },
  {
    id: 7,
    title: 'BYD Sealion 7: Mobil Listrik untuk Keluarga Modern',
    description:
      'Ketahui kenapa BYD Sealion 7 adalah pilihan ideal untuk keluarga yang aktif.',
    image: bydsealionKeluarga,
    slug: 'mobil-listrik-keluarga-byd-sealion-7',
    contentLength: '450 kata',
  },
  {
    id: 8,
    title: 'Cara Memesan BYD Sealion 7 di Dealer Serpong',
    description:
      'Panduan lengkap untuk memesan BYD Sealion 7 melalui Dealer BYD Serpong.',
    image: bydsealionPesan,
    slug: 'cara-memesan-byd-sealion-7',
    contentLength: '400 kata',
  },
  {
    id: 9,
    title: 'Promo Terbaru untuk BYD Sealion 7 di Serpong',
    description:
      'Dapatkan promo menarik saat membeli BYD Sealion 7 di Dealer BYD Serpong.',
    image: bydsealionSerpong,
    slug: 'promo-byd-sealion-7-serpong',
    contentLength: '450 kata',
  },
  {
    id: 10,
    title: 'BYD Atto 1: Mobil Listrik Mungil dan Canggih',
    description:
      'Kenali fitur, teknologi, dan keunggulan BYD Atto 1 sebagai city car listrik untuk mobilitas harian.',
    image: seagullpeluncuran,
    slug: 'peluncuran-byd-atto1-indonesia',
    isStaticRoute: true,
  },
  {
    id: 11,
    title: 'BYD Atto 1: Pilihan Warna BYD Atto 1 di Indonesia',
    description:
      'Lihat pilihan warna BYD Atto 1 dan pilih warna yang paling cocok untuk pembelian di Indonesia.',
    image: warnaseagull,
    slug: 'pilihan-warna-byd-atto1',
    isStaticRoute: true,
  },
  {
    id: 12,
    title: 'BYD Atto 1: Interior Atto 1 Indonesia',
    description:
      'Lihat tampilan interior BYD Atto 1 Indonesia, mulai dari kabin, jok, dashboard, sampai fitur kenyamanan.',
    image: interiorseagull,
    slug: 'interior-byd-atto1',
    isStaticRoute: true,
  },
  {
    id: 13,
    title: 'BYD Atto 1: Detail Eksterior Atto 1 yang Stylish',
    description:
      'Lihat desain eksterior BYD Atto 1 yang modern, ringkas, dan cocok untuk jalanan Indonesia.',
    image: exteriorseagull,
    slug: 'eksterior-byd-atto1',
    isStaticRoute: true,
  },
  {
    id: 14,
    title: 'BYD Atto 1: Fitur BYD Atto 1 untuk Harian',
    description:
      'Kenali fitur BYD Atto 1 yang mendukung mobilitas urban, efisiensi, dan kenyamanan berkendara harian.',
    image: seagullfitur,
    slug: 'fitur-byd-atto1',
    isStaticRoute: true,
  },
  {
    id: 15,
    title:
      'BYD Denza D9 Indonesia: Mobil Listrik Canggih dengan Performa Tinggi',
    description:
      'BYD Denza D9, mobil listrik 2025 untuk rakyat Indonesia. Performa tinggi, desain mewah, dan teknologi canggih kini hadir di BSD Serpong.',
    image: denzad9spect,
    slug: 'byd-denzad9-indonesia',
    isStaticRoute: true,
  },
  {
    id: 16,
    title:
      'Fitur & Spesifikasi DENZA B5: DM-O, 4x4, DiSus-P, dan EV Range 90 km',
    description:
      'Kupas fitur utama DENZA B5 untuk Indonesia: DM-O plug-in hybrid, output 400 kW, 760 Nm, 0–100 4,8 detik, baterai 31,8 kWh, EV range WLTC 90 km, ADAS, V2L, dan fitur pintar.',
    image: denzad9spect,
    slug: 'fitur-denza-b5',
    isStaticRoute: true,
    contentLength: '900 kata',
  },
  {
    id: 17,
    title: 'Konsultasi BYD Atto 1 dengan Junius di BYD BSD Serpong',
    description:
      'Halaman support untuk kontak langsung dengan Junius, follow up unit, dan booking test drive BYD Atto 1 di BYD BSD Serpong.',
    image: seagullpeluncuran,
    slug: 'byd-atto-1-bsd-serpong-junius',
    isStaticRoute: true,
    contentLength: '900 kata',
  },
  {
    id: 18,
    title:
      'Harga BYD Atto 1 NIK 2026 BSD | Dynamic 205, Premium 245',
    description:
      'Cari harga BYD Atto 1 NIK 2026? Dynamic Rp205 juta dan Premium Rp245 juta, lengkap dengan update fitur dan booking test drive di BYD BSD Serpong.',
    image: seagullpeluncuran,
    slug: 'harga-byd-atto-1-bsd-serpong-junius',
    isStaticRoute: true,
    contentLength: '850 kata',
  },
  {
    id: 19,
    title: 'Denza D9 Indonesia: MPV Listrik Mewah Pesaing Berat Alphard',
    description:
      'Cek harga, spesifikasi, dan kenyamanan interior Denza D9. MPV listrik premium dari BYD yang siap merajai jalanan Indonesia.',
    image: denzad9,
    slug: 'denza-d9-indonesia-mpv-mewah',
    contentLength: '950 kata',
    isStaticRoute: true,
  },
  {
    id: 20,
    title: 'BYD Atto 3 Indonesia: SUV Listrik Stylish & Harga Terbaru 2026',
    description:
      'Cek harga BYD Atto 3 terbaru 2026. SUV listrik stylish, nyaman untuk harian, bebas ganjil genap, dan pajak lebih hemat. Test drive sekarang di BSD Serpong!',
    image: bydatto3,
    slug: 'atto-3-suv-listrik-stylish',
    contentLength: '900 kata',
    isStaticRoute: true,
  },
  {
    id: 21,
    title:
      'BYD M6 Indonesia: MPV Listrik 7-Seater Keluarga & Harga Terbaru 2026',
    description:
      'Cek harga BYD M6 mulai Rp383 Juta. MPV listrik keluarga pertama dengan fitur V2L untuk camping, jarak tempuh 530km, dan bebas ganjil genap Jakarta.',
    image: m6HeroV2L,
    slug: 'byd-m6-mpv-listrik-keluarga',
    contentLength: '1050 kata',
    isStaticRoute: true,
  },
  {
    id: 22,
    title: 'BYD Sealion 7 Indonesia: Sport SUV Listrik 523 HP & Harga OTR 2026',
    description:
      'Rasakan torsi 690 Nm dari BYD Sealion 7. Cek harga varian Performance AWD, jarak tempuh 567km, dan info charging station BSD terbaru.',
    image: sealionhero,
    slug: 'sealion-7-suv-listrik-sporty',
    contentLength: '900 kata',
    isStaticRoute: true,
  },
  {
    id: 23,
    title: 'BYD M6 DM Indonesia 2026: Harga Mulai Rp298 Juta',
    description:
      'Kenali BYD M6 DM, MPV plug-in hybrid Dual Mode dengan harga Rp298-390 juta OTR Jakarta, baterai 18 kWh, tangki 52 liter, dan range 1200 km NEDC.',
    image: m6dmBlog,
    slug: 'byd-m6-dm-indonesia',
    contentLength: '950 kata',
    isStaticRoute: true,
  },
  {
    id: 24,
    title: 'Harga BYD M6 DM 2026: 5 Varian Mulai Rp298 Juta',
    description:
      'Cek harga lima varian BYD M6 DM dari Classic Standard Rp298 juta hingga Cross Superior Captain Rp390 juta OTR Jakarta.',
    image: m6dmHarga,
    slug: 'harga-byd-m6-dm-bsd-serpong',
    contentLength: '950 kata',
    isStaticRoute: true,
    featured: true,
  },
  {
    id: 25,
    title: 'Perubahan Fitur BYD Atto 1 NIK 2026: Dynamic & Premium',
    description:
      'Ringkasan perubahan fitur BYD Atto 1 NIK 2026: retract mirror, shift by wire, electric seat di kedua varian, 360 camera Premium, layar PAD fixed, dan fitur yang disesuaikan.',
    image: atto1Perubahan,
    slug: 'perubahan-fitur-byd-atto-1-nik-2026',
    contentLength: '950 kata',
    isStaticRoute: true,
  },
];

function Blog() {
  const [page, setPage] = useState(1);
  const blogsPerPage = 6;

  const validBlogs = blogs
    .filter((b) => b.title && b.slug)
    .sort((a, b) => b.id - a.id);

  const featuredBlog = validBlogs.find((blog) => blog.featured) || validBlogs[0];
  const listBlogs = validBlogs.filter((blog) => blog.slug !== featuredBlog?.slug);
  const startIndex = (page - 1) * blogsPerPage;
  const endIndex = startIndex + blogsPerPage;
  const currentBlogs = listBlogs.slice(startIndex, endIndex);
  const pageCount = Math.ceil(listBlogs.length / blogsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const blogJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: 'Blog Mobil Listrik BYD BSD Serpong',
    description:
      'Artikel harga, spesifikasi, promo, dan panduan test drive mobil BYD dan Denza di BSD Serpong.',
    url: 'https://bydbsdserpong.com/blog',
    blogPost: validBlogs.map((blog) => ({
      '@type': 'BlogPosting',
      mainEntityOfPage: absoluteUrl(`/blog/${blog.slug}`),
      headline: blog.title,
      image: absoluteUrl(blog.image),
      url: absoluteUrl(`/blog/${blog.slug}`),
      description: blog.description,
      articleSection: getBlogCategory(blog),
      wordCount: blog.contentLength
        ? parseInt(blog.contentLength.replace(' kata', ''), 10)
        : undefined,
      author: {
        '@type': 'Person',
        name: 'Junius',
      },
      publisher: {
        '@id': 'https://bydbsdserpong.com/#dealer',
      },
    })),
  };

  return (
    <Box
      component='main'
      sx={{
        backgroundColor: '#f5f7fa',
        minHeight: '100vh',
        px: { xs: 2, sm: 4, md: 6 },
        pt: { xs: 12, sm: 14 },
        pb: { xs: 6, md: 9 },
      }}
    >
      <PageSeo
        title='Blog BYD BSD Serpong | Harga, Promo, Spesifikasi Mobil BYD'
        description='Baca artikel BYD BSD Serpong tentang harga, promo, spesifikasi, test drive, dan perbandingan mobil BYD Atto 1, M6 DM, M6, Sealion 7, Denza D9, dan Denza B5.'
        keywords={[
          ...keywordSets.localDealer,
          'blog BYD Indonesia',
          'harga mobil listrik BYD',
          'promo BYD Tangerang',
          'spesifikasi BYD Indonesia',
          'BYD M6 DM Indonesia',
        ]}
        path='/blog'
        image={sealionhero}
        jsonLd={[
          blogJsonLd,
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'Blog BYD BSD Serpong', path: '/blog' },
          ]),
        ]}
      />

      <Box sx={{ maxWidth: 1280, mx: 'auto' }}>
        <Breadcrumbs aria-label='breadcrumb' sx={{ mb: 3, color: '#667085' }}>
          <Link underline='hover' color='inherit' component={RouterLink} to='/'>
            Home
          </Link>
          <Typography color='text.primary'>Blog</Typography>
        </Breadcrumbs>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', lg: '0.95fr 1.05fr' },
            gap: { xs: 3, md: 5 },
            alignItems: 'end',
            mb: { xs: 4, md: 5 },
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#2d6cdf',
                fontWeight: 900,
                letterSpacing: 0.4,
                textTransform: 'uppercase',
                fontSize: '0.82rem',
              }}
            >
              Artikel BYD BSD Serpong
            </Typography>
            <Typography
              variant='h1'
              component='h1'
              sx={{
                mt: 1,
                fontWeight: 900,
                lineHeight: 1,
                color: '#111827',
                fontSize: { xs: '2.35rem', sm: '3.2rem', md: '4rem' },
              }}
            >
              Panduan Mobil Listrik BYD
            </Typography>
          </Box>

          <Box>
            <Typography
              sx={{
                color: '#4b5563',
                lineHeight: 1.75,
                fontSize: { xs: '1rem', md: '1.06rem' },
              }}
            >
              Informasi harga, promo, spesifikasi, perbandingan, dan tips
              memilih mobil listrik BYD dan Denza dari BYD BSD Serpong.
            </Typography>
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
              }}
            >
              {['Harga', 'Spesifikasi', 'Promo', 'Test Drive'].map((topic) => (
                <Box
                  key={topic}
                  sx={{
                    px: 1.5,
                    py: 0.8,
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    border: '1px solid rgba(45,108,223,0.18)',
                    color: '#1f2937',
                    fontWeight: 800,
                    fontSize: '0.9rem',
                  }}
                >
                  {topic}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {featuredBlog && (
          <Box
            component='article'
            itemScope
            itemType='https://schema.org/BlogPosting'
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1.08fr 0.92fr' },
              gap: { xs: 0, md: 0 },
              overflow: 'hidden',
              borderRadius: '8px',
              backgroundColor: '#111827',
              mb: { xs: 4, md: 5 },
              boxShadow: '0 18px 40px rgba(16,24,40,0.14)',
            }}
          >
            <Box
              component={RouterLink}
              to={`/blog/${featuredBlog.slug}`}
              aria-label={`Baca ${featuredBlog.title}`}
              sx={{
                display: 'block',
                minHeight: { xs: 260, md: 440 },
                overflow: 'hidden',
                textDecoration: 'none',
                '&:hover img': { transform: 'scale(1.05)' },
              }}
            >
              <Box
                component='img'
                src={featuredBlog.image}
                alt={featuredBlog.title}
                itemProp='image'
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  transition: 'transform 0.35s ease',
                }}
              />
            </Box>

            <Box
              sx={{
                p: { xs: 2.5, sm: 4, md: 5 },
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  alignSelf: 'flex-start',
                  px: 1.2,
                  py: 0.5,
                  borderRadius: '8px',
                  backgroundColor: '#2d6cdf',
                  color: '#fff',
                  fontWeight: 900,
                  fontSize: '0.78rem',
                  textTransform: 'uppercase',
                }}
              >
                Artikel Pilihan
              </Typography>
              <Typography
                component='h2'
                itemProp='headline'
                sx={{
                  mt: 2,
                  fontWeight: 900,
                  lineHeight: 1.08,
                  fontSize: { xs: '1.8rem', sm: '2.35rem', md: '2.8rem' },
                }}
              >
                <Link
                  component={RouterLink}
                  to={`/blog/${featuredBlog.slug}`}
                  underline='none'
                  sx={{
                    color: '#fff',
                    '&:hover': { color: '#dbe8ff' },
                  }}
                >
                  {featuredBlog.title}
                </Link>
              </Typography>
              <Typography
                itemProp='description'
                sx={{
                  mt: 2,
                  color: 'rgba(255,255,255,0.78)',
                  lineHeight: 1.75,
                  fontSize: { xs: '1rem', md: '1.08rem' },
                }}
              >
                {featuredBlog.description}
              </Typography>
              <Box sx={{ mt: 3 }}>
                <Button
                  component={RouterLink}
                  to={`/blog/${featuredBlog.slug}`}
                  variant='contained'
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 900,
                    px: 3,
                    py: 1.2,
                    backgroundColor: '#2d6cdf',
                    '&:hover': { backgroundColor: '#1f5fc8' },
                  }}
                >
                  Baca Artikel
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1.5,
            mb: 2.5,
          }}
        >
          <Typography
            component='h2'
            sx={{
              fontSize: { xs: '1.7rem', md: '2.2rem' },
              fontWeight: 900,
              color: '#111827',
              lineHeight: 1.15,
            }}
          >
            Artikel Terbaru
          </Typography>
          <Typography sx={{ color: '#667085', fontWeight: 700 }}>
            {validBlogs.length} artikel tersedia
          </Typography>
        </Box>

        {currentBlogs.length === 0 ? (
          <Typography color='error' textAlign='center' mt={4}>
            Tidak ada artikel blog yang tersedia.
          </Typography>
        ) : (
          <Box
            component='section'
            aria-label='Daftar artikel BYD BSD Serpong'
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
                md: '1fr 1fr 1fr',
              },
              gap: { xs: 2.5, md: 3 },
            }}
          >
            {currentBlogs.map((blog) => (
              <ArticleCard key={blog.id} blog={blog} />
            ))}
          </Box>
        )}

        {pageCount > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handlePageChange}
              color='primary'
              shape='rounded'
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

function ArticleCard({ blog }) {
  const category = getBlogCategory(blog);

  return (
    <Box
      component='article'
      itemScope
      itemType='https://schema.org/BlogPosting'
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRadius: '8px',
        backgroundColor: '#fff',
        border: '1px solid rgba(17,24,39,0.08)',
        boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 18px 34px rgba(16,24,40,0.13)',
        },
      }}
    >
      <Box
        component={RouterLink}
        to={`/blog/${blog.slug}`}
        aria-label={`Baca ${blog.title}`}
        sx={{
          position: 'relative',
          display: 'block',
          height: 220,
          overflow: 'hidden',
          textDecoration: 'none',
          '&:hover img': { transform: 'scale(1.05)' },
        }}
      >
        <Box
          component='img'
          src={blog.image}
          alt={blog.title}
          itemProp='image'
          loading='lazy'
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: 'transform 0.35s ease',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            left: 12,
            top: 12,
            px: 1.1,
            py: 0.5,
            borderRadius: '8px',
            backgroundColor: 'rgba(17,24,39,0.86)',
            color: '#fff',
            fontWeight: 900,
            fontSize: '0.75rem',
          }}
        >
          {category}
        </Box>
      </Box>

      <Box sx={{ p: 2.5, flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          component='h3'
          itemProp='headline'
          sx={{
            m: 0,
            fontWeight: 900,
            lineHeight: 1.25,
            fontSize: '1.22rem',
          }}
        >
          <Link
            component={RouterLink}
            to={`/blog/${blog.slug}`}
            underline='none'
            sx={{
              color: '#111827',
              '&:hover': { color: '#2d6cdf' },
            }}
          >
            {blog.title}
          </Link>
        </Typography>
        <Typography
          itemProp='description'
          sx={{
            mt: 1.2,
            color: '#4b5563',
            lineHeight: 1.65,
            fontSize: '0.95rem',
          }}
        >
          {blog.description}
        </Typography>

        <Box
          sx={{
            mt: 'auto',
            pt: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography sx={{ color: '#667085', fontSize: '0.86rem' }}>
            {blog.contentLength || 'Artikel panduan'}
          </Typography>
          <Button
            component={RouterLink}
            to={`/blog/${blog.slug}`}
            variant='outlined'
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 900,
              px: 2,
              borderColor: '#2d6cdf',
              color: '#2d6cdf',
              '&:hover': {
                borderColor: '#1f5fc8',
                backgroundColor: '#edf4ff',
              },
            }}
          >
            Baca
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

function getBlogCategory(blog) {
  const text = `${blog.title} ${blog.description}`.toLowerCase();

  if (text.includes('harga') || text.includes('promo')) return 'Harga';
  if (text.includes('spesifikasi') || text.includes('fitur')) return 'Spesifikasi';
  if (text.includes('denza')) return 'Denza';
  if (text.includes('atto')) return 'Atto';
  if (text.includes('m6')) return 'M6';
  if (text.includes('sealion')) return 'Sealion 7';
  return 'Panduan';
}

export default Blog;
